<template>
    <div class="form-container">
        <h2>{{ isEditing ? 'Edit' : 'Add' }} Counselor</h2>
        <hr>

        <div v-if="errorMessage" class="error-message">
            <p>{{ errorMessage }}</p>
        </div>
        <form @submit.prevent="submitForm">
            <label>Full Name <span class="required">*</span></label>
            <input type="text" v-model="counselor.name" placeholder="Full Name" required>
            <!-- Display error if exists -->
            <div v-if="errors.name" class="error-message">{{ errors.name[0] }}</div>

            <label>Email <span class="required">*</span></label>
            <input type="email" v-model="counselor.email" placeholder="Email" required>
            <!-- Display error if exists -->
            <div v-if="errors.email" class="error-message">{{ errors.email[0] }}</div>


            <label>Specialization (Optional)</label>
            <input type="text" v-model="counselor.specialization" placeholder="Specialization">
            <!-- Display error if exists -->
            <div v-if="errors.specialization" class="error-message">{{ errors.specialization[0] }}</div>

            <label>Password <span class="required" v-if="!isEditing">*</span></label>
            <input type="password" v-model="counselor.password" placeholder="Password">
            <!-- Display error if exists -->
            <div v-if="errors.password" class="error-message">{{ errors.password[0] }}</div>

            <div class="btn-group">
                <button type="submit" class="btn btn-sm">{{ isEditing ? 'Update' : 'Add' }}</button>
                <button type="button" class="btn btn-sm cancel-btn"
                    @click="$router.push('/dashboard/counselors')">Cancel</button>
            </div>
        </form>

        <div v-if="loading" class="loading-overlay">
            <div class="spinner"></div>
        </div>
    </div>
</template>


<script>
// import axios from 'axios';

export default {
    data() {
        return {
            counselor: { name: '', email: '', phone: '', specialization: '', password: '', user_id: 0, },
            loading: false,
            isEditing: false,
            errorMessage: null,
            errors: {},
        };
    },
    methods: {
        async submitForm() {
            this.loading = true;
            this.errorMessage = null;  // Reset any previous errors
            this.errors = {};
            try {
                if (this.isEditing) {
                    await this.$api.put(`/counselors/${this.$route.params.id}`, this.counselor);
                } else {
                    await this.$api.post('/counselors', this.counselor);
                }
                this.$router.push('/dashboard/counselors');
            } catch (error) {
                if (error.response && error.response.status === 401) {
                    this.errorMessage = 'You are not authorized to perform this action. Please log in.';
                } else if (error.response && error.response.status === 422) {
                    // Handle validation errors
                    this.errors = error.response.data.errors;
                } else {
                    console.error("Error saving counselor:", error);
                    this.errorMessage = 'An error occurred while saving the counselor. Please try again later.';
                }
            }
            this.loading = false;
        },
        async fetchCounselor() {
            if (this.$route.params.id) {
                this.isEditing = true;
                this.loading = true;
                try {
                    const response = await this.$api.get(`/counselors/${this.$route.params.id}`);

                    if (!response.data.user) {
                        this.errorMessage = "An error occured on server, due to data inconsistancy, Plese contact admin";

                    } else {
                        this.counselor.name = response.data.user.name;
                        this.counselor.email = response.data.user.email;
                        this.counselor.specialization = response.data.specialization;
                    }


                    this.counselor.user_id = response.data.user_id;
                } catch (error) {
                    console.error("Error fetching counselor:", error);
                }
                this.loading = false;
            }

        },
    },
    mounted() {
        this.fetchCounselor();
    }
};
</script>

<style scoped></style>